module.exports = __webpack_public_path__ + "img/freespin2.f4735c07.png";